import clsx from 'clsx';

interface Props {
  orientation?: 'horizontal' | 'vertical';
  elements: SingleButtonInput[];
}

interface SingleButtonInput {
  text: string;
  onClick?: () => void;
  disabled: boolean;
}
export function ButtonGroup(props: Props) {
  const { orientation = 'horizontal', elements } = props;
  if (orientation === 'horizontal') {
    return (
      <span className="relative z-0 inline-flex rounded-md shadow-sm">
        {elements.map((item, index, arr) => (
          <button
            key={index}
            type="button"
            className={clsx(
              'focus:border-primary-500 focus:ring-primary-500 relative -ml-px inline-flex items-center border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50 focus:z-10 focus:outline-none focus:ring-1',
              index === 0 &&
                'focus:border-primary-500 focus:ring-primary-500 relative inline-flex items-center rounded-l-md border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50 focus:z-10 focus:outline-none focus:ring-1',
              index === arr.length - 1 &&
                'focus:border-primary-500 focus:ring-primary-500 relative -ml-px inline-flex items-center rounded-r-md border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50 focus:z-10 focus:outline-none focus:ring-1'
            )}
            onClick={item.onClick}
            disabled={item.disabled}
          >
            {item.text}
          </button>
        ))}
      </span>
    );
  } else {
    return (
      <div className="relative z-0 rounded-md shadow-sm">
        {elements.map((item, index, arr) => (
          <div className="flex">
            <button
              type="button"
              className={clsx(
                'focus:border-primary-500 focus:ring-primary-500 relative -ml-px grow items-center border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50 focus:z-10 focus:outline-none focus:ring-1',
                index === 0 &&
                  'focus:border-primary-500 focus:ring-primary-500 relative items-center rounded-t-md border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50 focus:z-10 focus:outline-none focus:ring-1',
                index === arr.length - 1 &&
                  'focus:border-primary-500 focus:ring-primary-500 relative -ml-px items-center rounded-b-md border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50 focus:z-10 focus:outline-none focus:ring-1'
              )}
              onClick={item.onClick}
              disabled={item.disabled}
            >
              {item.text}
            </button>
          </div>
        ))}
      </div>
    );
  }
}

export default ButtonGroup;
